import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty, isNaN } from 'lodash';

import { Button, TextField, Stack, Box } from '@mui/material';

import { URL_REGEX, YOUTUBE_URL_REGEX } from '../../../../api/Videos/Videos';

import * as templateOps from '../../../../api/AnnotationTemplates/annotation-template-operations';

const EDITION_MODE = 'edition';
const PREVIEW_MODE = 'preview';

const TemplateButtonItem = ({
  variantButton,
  colorButton,
  previewMode,
  elementItem,
  updateAnnotationFields
}) => {
  const [link, setLink] = React.useState(templateOps.getElementHiperLink(elementItem));
  const [textButton, setTextButton] = React.useState(templateOps.getElementValue(elementItem));
  const [isSharedMap, setIsSharedMap] = React.useState(false);
  const [alertUrl, setAlertUrl] = React.useState(false);
  const [lat, setLat] = React.useState('none');
  const [lng, setLng] = React.useState('none');
  const [zoom, setZoom] = React.useState('none');
  const [urlMapSharedState, setUrlMapSharedState] = React.useState('');
  const [showAlertCoords, setShowAlertCoords] = React.useState(false);

  const handleTextButton = text => {
    updateAnnotationFields(elementItem, 'value', text);
    setTextButton(text);
  };

  const handleLink = url => {
    const isValid = YOUTUBE_URL_REGEX.test(url) || URL_REGEX.test(url);
    if (isValid) {
      const existCoords = url.includes('lng=') && url.includes('&lat=');
      if (existCoords) {
        const urlMapShared = url.substring(0, url.lastIndexOf('/') + 1);
        const subStringCoords = url.substring(url.lastIndexOf('/') + 1);
        const lngString = subStringCoords.substring(
          subStringCoords.indexOf('=') + 1,
          subStringCoords.indexOf('&')
        );
        const latString = subStringCoords.substring(
          subStringCoords.indexOf('lat') + 4,
          subStringCoords.lastIndexOf('&')
        );
        const zoomString = subStringCoords.substring(subStringCoords.lastIndexOf('=') + 1);
        setLat(latString);
        setLng(lngString);
        setZoom(zoomString);
        setUrlMapSharedState(urlMapShared);
      }
      updateAnnotationFields(elementItem, 'hiperLink', url);
      setIsSharedMap(existCoords);
      setLink(url);
      setAlertUrl(false);
    } else {
      setAlertUrl(true);
    }
  };

  React.useEffect(() => {
    if (!isEmpty(urlMapSharedState)) {
      const latIsNumber = !isNaN(Number(lat));
      const lngIsNumber = !isNaN(Number(lng));
      const zoomIsNumber = !isNaN(Number(zoom));
      if (latIsNumber && lngIsNumber && zoomIsNumber) {
        const newLocationLink = `lng=${lng}&lat=${lat}&zoom=${zoom}`;
        const newUrl = urlMapSharedState + newLocationLink;
        updateAnnotationFields(elementItem, 'hiperLink', newUrl);
        setShowAlertCoords(false);
      } else {
        setShowAlertCoords(true);
      }
    }
  }, [lat, lng, zoom]);

  return (
    <>
      {previewMode === PREVIEW_MODE && (
        <>
          <Button
            variant={variantButton}
            color={colorButton}
            disabled={!!isEmpty(link)}
            onClick={() => window.open(link)}
          >
            {isEmpty(textButton) ? 'Open Link' : textButton}
          </Button>
        </>
      )}
      {previewMode === EDITION_MODE && (
        <>
          <br />
          <Box style={{ margintop: '2%' }}>
            <TextField
              placeholder={isEmpty(textButton) ? 'Open Link' : textButton}
              onChange={event => handleTextButton(event.target.value)}
              size="small"
              label="Text button"
              color="primary"
              focused
            />
          </Box>
          <br />
          <Box margintop="2%">
            <TextField
              placeholder="Introduzca una url"
              onChange={event => handleLink(event.target.value)}
              size="small"
              label="Link"
              color="primary"
              focused
              fullWidth
              margintop="2%"
            />
            {alertUrl && <p style={{ color: 'red' }}>Url not valid</p>}
          </Box>
          <br />
          {isSharedMap && (
            <>
              <Stack direction="row" justifycontent="space-between" margintop="2%">
                <TextField
                  paddingtop="4%"
                  onChange={event => setLat(event.target.value)}
                  size="small"
                  label="Lat"
                  color="primary"
                  focused
                  value={lat}
                  width="40%"
                />
                <TextField
                  width="40%"
                  paddingtop="4%"
                  onChange={event => setLng(event.target.value)}
                  size="small"
                  label="Lng"
                  color="primary"
                  focused
                  value={lng}
                />
                <TextField
                  paddingtop="4%"
                  onChange={event => setZoom(event.target.value)}
                  size="small"
                  label="Zoom"
                  color="primary"
                  focused
                  value={zoom}
                  width="20%"
                />
              </Stack>
              {showAlertCoords && <p style={{ color: 'red' }}>Coodinates or zoom not valid</p>}
            </>
          )}
        </>
      )}
    </>
  );
};
TemplateButtonItem.defaultProps = {
  variantButton: 'outlined',
  colorButton: 'primary',
  updateAnnotationFields: () => {}
};
TemplateButtonItem.propTypes = {
  variantButton: PropTypes.string,
  colorButton: PropTypes.string,
  previewMode: PropTypes.string.isRequired,
  elementItem: PropTypes.object.isRequired,
  updateAnnotationFields: PropTypes.func
};
export default TemplateButtonItem;
